/**
 * @description: 营业收入日报表
 * @author: lyr
*/
<template>
    <div class="business-income-day-report">
        <div class="list">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable  placeholder="请选择门店" @change="changeShop($event)">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item label="收入总额包含支付类型">
                    <el-input placeholder="请选择支付类型" v-model="pay_platform_str" readonly @click.native="openPayPlatformPop"></el-input>
                </el-form-item>
                <el-form-item label="收入类型">
                    <el-input placeholder="请选择收入类型" v-model="income_type_str" readonly @click.native="openIncomeTypePop"></el-input>
                </el-form-item>
                <el-form-item label="包厢区域">
                    <el-input placeholder="请选择包厢区域" v-model="room_area_str" readonly @click.native="openRoomAreaPop"></el-input>
                </el-form-item>
                <el-form-item label="价格策略">
                    <el-select v-model="list_form.bill_goods_price_rule_id" filterable  placeholder="请选择价格策略">
                        <el-option v-for="item in bill_price_rule_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button :type="statement_type=='1'?'primary':''" @click="changeReportType(1)">按支付方式</el-button>
                    <el-button :type="statement_type=='2'?'primary':''" @click="changeReportType(2)">按收入类型</el-button>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="listExport">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                max-height="650"
                :data="list_table"
                @sort-change="listOrder">
                <el-table-column :prop="item.key" 
                    :label="item.name" 
                    v-for="item in column_arr"
                    :key="item.key"
                    min-width="110px"
                    :sortable="item.key=='business_date'?'custom':false"
                    :fixed="(item.key=='business_date'||item.key=='total_income')&&statement_type==1"
                    >
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="page_size"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
            <div class="check-sum" @click="doSum">查看合计金额</div>
        </div>
        <!-- 包厢区域选择 -->
        <div class="room-area-pop" ref="room_area_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllRoomArea" @change="handleCheckAllRoomAreaChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.room_area_arr" @change="handleCheckRoomAreaChange">
                    <el-checkbox v-for="item in room_area_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
        <!-- 支付类型选择 -->
        <div class="pay-platform-pop" ref="pay_platform_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllPayPlatform" @change="handleCheckAllPayPlatformChange">全选</el-checkbox>
                <span class="red-tip-special">（注：未勾选的支付类型，将不在列表上显示）</span>
                <el-checkbox-group v-model="list_form.pay_platform_arr" @change="handleCheckPayPlatformChange">
                    <el-checkbox v-for="item in pay_platform_arr" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
        <!-- 收入类型选择 -->
        <div class="income-type-pop" ref="income_type_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllIncomeType" @change="handleCheckAllIncomeTypeChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.income_type_arr" @change="handleCheckIncomeTypeChange">
                    <el-checkbox v-for="item in income_type_arr" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
        <!-- 合计弹窗 -->
        <div class="sum-pop ele-hide" ref="sum_pop">
            <el-table
                v-loading="pop_loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                style="width:100%"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :data="sum_table"
                :key="sumTableKey">
                <el-table-column :prop="item.prop" 
                    :label="item.name" 
                    v-for="item in sum_column_arr"
                    :key="item.name"
                >
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'business-income-day-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                room_area_list: [],
                pay_platform_arr: [],
                income_type_arr: [],
                bill_price_rule_list: [],
                checkAllRoomArea: false,
                checkAllPayPlatform: false,
                checkAllIncomeType: false,
                statement_type: 1, //报表类型，1：按支付方式统计，2：按收入类型统计
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    pay_platform_arr: [],
                    income_type_arr: [],
                    room_area_arr: [],
                    bill_goods_price_rule_id: '',
                    order_by: "business_date_desc", // 排序，business_date_asc：日期正序，business_date_desc：日期倒序
				},
				list_table: [],
				list_page: 1,
                list_total: 0,
                page_size: 100,
                column_arr: [],
                sum_table: [],
                sum_column_arr: [],
                pop_loading: false,
                sumTableKey: Math.random(),
                isSuming: false,
            }
        },
        computed: {
            room_area_str() {
                if (this.list_form.room_area_arr.length == 0) {
                    return ''
                }else if(this.list_form.room_area_arr.length == this.room_area_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.room_area_arr.forEach(v => {
                        this.room_area_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },

            pay_platform_str() {
                if (this.list_form.pay_platform_arr.length == 0) {
                    return ''
                }else if(this.list_form.pay_platform_arr.length == this.pay_platform_arr.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.pay_platform_arr.forEach(v => {
                        this.pay_platform_arr.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },

            income_type_str() {
                if (this.list_form.income_type_arr.length == 0) {
                    return ''
                }else if(this.list_form.income_type_arr.length == this.income_type_arr.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.income_type_arr.forEach(v => {
                        this.income_type_arr.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },
        },
        mounted: function() {
            // 日期
            this.list_form.start_time = moment().format('YYYY-MM-DD 08:00');
            this.list_form.end_time = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.getRoomArea(this.list_form.shop_id)
                this.getPayIncomeType(this.list_form.shop_id)
                this.getBillPriceRule(this.list_form.shop_id)
            })
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢区域
            getRoomArea: function(shop_id) {
                const _this = this;
                Vue.axios.post('Shop/getRoomArea', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_area_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取支付类型、收入类型
            getPayIncomeType: function(shop_id) {
                const _this = this;
                Vue.axios.post('PayLog/getDailyIncomeParams', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id,
                            "statement_type": _this.statement_type
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.pay_platform_arr = res.data.response.result.pay_platform_arr;
                        _this.income_type_arr = res.data.response.result.income_type_arr;
                        _this.list_form.pay_platform_arr = []
                        _this.list_form.income_type_arr = []
                        _this.pay_platform_arr.forEach(item => {
                            if (item.selected == '1') {
                                _this.list_form.pay_platform_arr.push(item.id)
                            }
                        })
                        _this.income_type_arr.forEach(item => {
                            if (item.selected == '1') {
                                _this.list_form.income_type_arr.push(item.id)
                            }
                        })
                        _this.checkAllPayPlatform = _this.list_form.pay_platform_arr.length === _this.pay_platform_arr.length
                        _this.checkAllIncomeType = _this.list_form.income_type_arr.length === _this.income_type_arr.length
                        _this.getList(1)
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取账单价格策略列表
            getBillPriceRule: function(shop_id) {
                const _this = this;
                Vue.axios.post('PublicData/api_getBillGoodsPriceRule', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.bill_price_rule_list = res.data.response.result;
                        _this.bill_price_rule_list.unshift({
                            id: '',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 切换报表类型
            changeReportType(type) {
                this.statement_type = type
                this.getPayIncomeType(this.list_form.shop_id)
            },

            getList(page) {
				const _this = this;

				_this.loading = true;
                _this.list_page = page
                const url = _this.statement_type == 1? 'PayLog/getDailyIncomeListByPayPlatform' : 'PayLog/getDailyIncomeListByIncomeType'
				Vue.axios.post(url, {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.page_size,
                            "start_date": _this.list_form.start_time,
                            "end_date": _this.list_form.end_time,
							"shop_id": _this.list_form.shop_id,
							"room_area_arr": _this.list_form.room_area_arr,
                            "pay_platform_arr": _this.list_form.pay_platform_arr,
                            "income_type_arr": _this.list_form.income_type_arr,
                            "bill_goods_price_rule_id": _this.list_form.bill_goods_price_rule_id,
                            "order_by": _this.list_form.order_by,
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.count)
						}
                        _this.column_arr = []
                        for(let [key, value] of Object.entries(res.data.response.result.column_arr)) {
                            _this.column_arr.push({key: key, name: value});
                        }
						_this.list_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            changeShop(val) {
                this.list_form.shop_id = val
                if (!!val) {
                    this.list_form.room_area_arr = []
                    this.list_form.pay_platform_arr = []
                    this.list_form.income_type_arr = []
                    this.list_form.bill_goods_price_rule_id = ''

                    this.getRoomArea(val)
                    this.getPayIncomeType(val)
                    this.getBillPriceRule(val)
                }
            },

            // 打开包厢区域选择弹窗
            openRoomAreaPop() {
                let _this = this
                let c_room_area_arr = _this.list_form.room_area_arr
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择包厢区域', true],
                    area: ['450px', ''], // 宽高
                    content: $(_this.$refs.room_area_pop),
                    cancel: function() {
                        _this.list_form.room_area_arr = c_room_area_arr
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.room_area_arr = c_room_area_arr
                    layer.closeAll()
                });
            },

            // 包厢区域全选
            handleCheckAllRoomAreaChange(val) {
                this.list_form.room_area_arr = []
                this.checkAllRoomArea = val
                if (val) {
                    this.room_area_list.forEach(item => {
                        this.list_form.room_area_arr.push(item.id)
                    })
                }
            },

            // 选择包厢区域
            handleCheckRoomAreaChange(val) {
                this.checkAllRoomArea = val.length === this.room_area_list.length
            },

            // 打开支付类型选择弹窗
            openPayPlatformPop() {
                let _this = this
                let c_pay_platform_arr = _this.list_form.pay_platform_arr
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['收入总额包含支付类型', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.pay_platform_pop),
                    cancel: function() {
                        _this.list_form.pay_platform_arr = c_pay_platform_arr
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.pay_platform_arr = c_pay_platform_arr
                    layer.closeAll()
                });
            },

            // 支付类型全选
            handleCheckAllPayPlatformChange(val) {
                this.list_form.pay_platform_arr = []
                this.checkAllPayPlatform = val
                if (val) {
                    this.pay_platform_arr.forEach(item => {
                        this.list_form.pay_platform_arr.push(item.id)
                    })
                }
            },

            // 选择支付类型
            handleCheckPayPlatformChange(val) {
                this.checkAllPayPlatform = val.length === this.pay_platform_arr.length
            },

            // 打开收入类型选择弹窗
            openIncomeTypePop() {
                let _this = this
                let c_income_type = _this.list_form.income_type_arr
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['收入类型', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.income_type_pop),
                    cancel: function() {
                        _this.list_form.income_type_arr = c_income_type
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.income_type_arr = c_income_type
                    layer.closeAll()
                });
            },

            // 收入类型全选
            handleCheckAllIncomeTypeChange(val) {
                this.list_form.income_type_arr = []
                this.checkAllIncomeType = val
                if (val) {
                    this.income_type_arr.forEach(item => {
                        this.list_form.income_type_arr.push(item.id)
                    })
                }
            },

            // 选择支付类型
            handleCheckIncomeTypeChange(val) {
                this.checkAllIncomeType = val.length === this.income_type_arr.length
            },

            // 表格排序
            listOrder(col) {
                if (col.prop == 'business_date') {
                    if (col.order == 'ascending') {
                        this.list_form.order_by = 'business_date_asc'
                    }else if (col.order == 'descending') {
                        this.list_form.order_by = 'business_date_desc'
                    }else {
                        this.list_form.order_by = ''
                    }
                }
                this.getList(1)
            },

			// 查询
			listQuery() {
                this.list_page = 1
				this.getList(this.list_page);
            },

            // 查看合计金额
            doSum() {
                if(this.isSuming) {
                    return;
                }
                this.isSuming = true;

                const _this = this;
                _this.pop_loading = true;
                Vue.axios.post('PayLog/getDailyIncomeSum', {})
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.sum_column_arr = []
                        _this.sum_table = []
                        for(let [key, value] of Object.entries(res.data.response.result.column_arr)) {
                                _this.sum_column_arr.push({ prop: key, name: value });
                            }
                        _this.sum_table.push(res.data.response.result.data);
                        _this.sumTableKey = Math.random();

                        layer.confirm('', {
                            skin: 'public-alert-skin',
                            type: 1,
                            btn: [], // 按钮
                            title: ['合计', true],
                            area: ['1000px', ''], // 宽高
                            content: $(_this.$refs.sum_pop),
                            offset: '260px',
                        });
                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                    _this.pop_loading = false;
                })
                .catch(err => {
                    layer.msg("出错啦");
                })
                .finally(() => {
                    this.isSuming = false;
                });
            },
            
            listExport: function() {
                const url = this.statement_type == 1? 'PayLog/exportDailyIncomeList?statement_type=1' : 'PayLog/exportDailyIncomeList?statement_type=2'
                window.location.href = Vue.ctUrl + url +
                    "&start_date=" + this.list_form.start_time +
                    "&end_date=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&room_area_arr=" + this.list_form.room_area_arr +
                    "&pay_platform_arr=" + this.list_form.pay_platform_arr +
                    "&income_type_arr=" + this.list_form.income_type_arr +
                    "&bill_goods_price_rule_id=" + this.list_form.bill_goods_price_rule_id +
                    "&order_by=" + this.list_form.order_by;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scope>
    .red-tip-special {
        color: red;
        margin-left: -90px;
    }

    .room-area-pop,
    .pay-platform-pop,
    .income-type-pop{
        display: none;
        .el-checkbox {
            width: 150px;
            margin-bottom: 10px;
            margin-right: 10px;
        }
    }

    .check-sum {
        margin-top: -30px;
        margin-left: 20px;
        color: #409EFF;
        cursor: pointer;
    }
</style>